import { render, staticRenderFns } from "./Numero.vue?vue&type=template&id=41c532e8&"
import script from "./Numero.vue?vue&type=script&lang=js&"
export * from "./Numero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports